import { useSyncExternalStore } from 'react';
import { ascoltaEsiti, chiudiEsito, esitiAdesso, type TipoEsito } from '../lib/esiti.js';

const ICONA: Record<TipoEsito, string> = { ok: '✅', no: '❌', forse: '⚠️' };

/**
 * 🆕 26/09/2026 — gli avvisi in basso al centro, uguali in ogni pagina. Li
 * mette qui il `MutationCache` (`main.tsx`), per ogni azione: vedi
 * `lib/esiti.ts`.
 */
export function Esiti(): React.JSX.Element {
  const esiti = useSyncExternalStore(ascoltaEsiti, esitiAdesso);
  return (
    <div className="avvisi-azioni" aria-live="polite">
      {esiti.map((e) => (
        <div
          key={e.id}
          className={`avviso-azione avviso-azione-${e.tipo}`}
          role={e.tipo === 'ok' ? 'status' : 'alert'}
        >
          <span aria-hidden="true">{ICONA[e.tipo]}</span>
          <div>
            <strong>{e.testo}</strong>
            {e.sotto && <span className="avviso-azione-sotto">{e.sotto}</span>}
          </div>
          <button
            type="button"
            className="piatto avviso-azione-chiudi"
            aria-label="Chiudi"
            onClick={() => chiudiEsito(e.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
